/*
 * Copyright (c) 2018. Unconventional Software Corporation
 */

import {Component, EventEmitter, Input, Output} from '@angular/core';
import {FormGroup, FormControl, Validators} from "@angular/forms";
import {PasswordStrengthValidator} from "./password-strength-validator";
import {GlobalValidator} from "../../shared/GlobalValidators";

@Component({
  selector: 'password-strength-bar',
  templateUrl: 'password-strength-bar.html',
  providers: [PasswordStrengthValidator]
})

export class PasswordStrengthBarComponent {

  //TODO:  This form still has some strange behaviours with validation.  Confirmation doesn't show.  Initial password is in BIG letters.
  signupForm: FormGroup;

  divErrClass: string;
  borderClass: string;

  lowercaseInvalid: boolean = true;
  uppercaseInvalid: boolean = true;
  symbolsInvalid: boolean = true;
  lengthInvalid: boolean = true;
  numberInvalid: boolean = true;

  readonly minPasswordLength: number = 6;
  passwordType: string = 'password';
  passwordIcon: string = 'eye-off';


  @Input() password: string;
  @Input() confirmPassword: string;

  @Output()
  passwordResult: EventEmitter<string> = new EventEmitter<string>();

  constructor() {
    console.log('Hello PasswordStrengthBar Component');

    this.signupForm = new FormGroup({
      'password': new FormControl({value: this.password}, <any>[Validators.required,
        Validators.minLength(this.minPasswordLength)]),
    });


    // this.signupForm = new FormGroup({
    //   'password': new FormControl({value: this.password}, <any>[Validators.required, new PasswordStrengthValidator(), Validators.minLength(6)]),
    //   'confirmPassword': new FormControl({value: this.confirmPassword}, [Validators.required, Validators.minLength(8)])
    // }, GlobalValidator.equalValueValidator('password', 'confirmPassword'));

    //Problem with AngularFire2 forces the passwords to be initialized with a password mask in place
    this.signupForm.controls['password'].setValue("");
    // this.signupForm.controls['confirmPassword'].setValue("");
    //Always has to have this class to avoid styling problems
    this.divErrClass = 'div-err';
  }


  emitPassword() {
    if (this.signupForm.valid) {
      this.passwordResult.emit(this.signupForm.controls['password'].value);
    }

    // if (this.signupForm.valid && !this.signupForm.controls['confirmPassword'].hasError('equalValue')) {
    //   this.passwordResult.emit(this.signupForm.controls['password'].value);
    // } else {
    //   this.passwordResult.emit(null);
    // }
  }

  setStrengthStatusColor() {

    this.emitPassword();

    if (!this.signupForm.controls['password'].valid) {

      if (this.signupForm.controls['password'].hasError('danger')) {

        this.divErrClass = 'div-err danger-err';
        this.borderClass = 'danger-border';

      } else if (this.signupForm.controls['password'].hasError('warning-danger')) {

        this.divErrClass = 'div-err warning-danger-err';
        this.borderClass = 'warning-danger-border';

      } else if (this.signupForm.controls['password'].hasError('warning-unsafe')) {

        this.divErrClass = 'div-err warning-unsafe-err';
        this.borderClass = 'warning-unsafe-border';

      } else if (this.signupForm.controls['password'].hasError('warning-safe')) {

        this.divErrClass = 'div-err warning-safe-err';
        this.borderClass = 'warning-safe-border';

      } else {

        this.divErrClass = 'div-err warning-danger-err';
        this.borderClass = 'warning-danger-border';
      }

    } else {

      this.divErrClass = 'div-err';
      this.borderClass = '';

    }

    // this.lowercaseInvalid = this.signupForm.controls['password'].hasError('lowercase');
    // this.uppercaseInvalid = this.signupForm.controls['password'].hasError('uppercase');
    // this.symbolsInvalid = this.signupForm.controls['password'].hasError('symbols');
    // this.numberInvalid = this.signupForm.controls['password'].hasError('numbers');
    this.lengthInvalid = this.signupForm.controls['password'].hasError('minlength') ||
      this.signupForm.controls['password'].hasError('required');
  }

  toggleShowPassword() {
    this.passwordType = this.passwordType === 'text' ? 'password' : 'text';
    this.passwordIcon = this.passwordIcon === 'eye-off' ? 'eye' : 'eye-off';
  }
}



// WEBPACK FOOTER //
// ./src/components/password-strength-bar/password-strength-bar.ts